import Select from 'react-select';
import { OptionType } from '../../types';

export const SelectWrapper = ({
    value,
    options,
    onChange,
}: {
    value?: OptionType,
    options: OptionType[],
    onChange: (newValue: OptionType | null) => void,
}) => {
    return (
        <Select<OptionType>
            value={value}
            onChange={onChange}
            options={options}
            classNames={{
                container: () => 'select-container',
                control: () => 'select-control',
                group: () => 'select-group',
                clearIndicator: () => 'select-clear-indicator',
                dropdownIndicator: () => 'select-dropdown-indicator',
                singleValue: () => 'select-single-value',
                placeholder: () => 'select-placeholder',
                input: () => 'select-input',
                indicatorsContainer: () => 'select-indicator-container',
                indicatorSeparator: () => 'select-indicator-separator',
                menu: () => 'select-menu',
                menuList: () => 'select-menu-list',
                menuPortal: () => 'select-menu-portal',
                option: () => 'select-option',
                valueContainer: () => 'select-value-container',
            }}
        />
    )
}